import { useAtomValue } from 'jotai';

import { ItemWrapper } from './index.styles';

import Heading from '../../../../../../heading';
import PageWrapper from '../../../../../../page_wrapper';
import Items from '../../main/offers/items';

import { vendorCardOffersState } from '../../../../../../../store';

export default function OffersMain() {
  const cardOffers = useAtomValue(vendorCardOffersState);

  return (
    <PageWrapper>
      <Heading align="center">News</Heading>
      <ItemWrapper>
        <Items items={cardOffers} />
      </ItemWrapper>
    </PageWrapper>
  );
}
